export type ThemeName = "light" | "dark";

const customProperties: Record<string, string> = {
  "ui.host.dark": "--cm-host-dark",
  "ui.host.dark2": "--cm-host-dark2",
  "ui.host.dark3": "--cm-host-dark3",
  "ui.textbox.back": "--cm-textbox-back",
  "ui.roles.groupbox.back": "--cm-roles-groupbox-back",
  "ui.roles.surface.back": "--cm-roles-surface-back",
  "ui.button.back": "--cm-button-back",
  "ui.button.fore": "--cm-button-fore",
  "ui.font.text": "--cm-font-text",
  "ui.sidebar.back": "--cm-sidebar-back",
};

export function getInitialTheme(): ThemeName {
  try {
    const stored = localStorage.getItem("cm-theme");
    if (stored === "light" || stored === "dark") return stored;
  } catch {
    // Die Systemeinstellung bleibt der sichere Fallback.
  }

  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function applyTheme(theme: ThemeName): void {
  const root = document.documentElement;
  root.dataset.theme = theme;
  root.classList.toggle("dark-theme", theme === "dark");
  root.classList.toggle("light-theme", theme === "light");
  try {
    localStorage.setItem("cm-theme", theme);
  } catch {
    // Das Theme funktioniert auch ohne persistenten Browser-Speicher.
  }
}

export function applyCustomTheme(values: Record<string, string>): void {
  const root = document.documentElement;
  for (const [key, property] of Object.entries(customProperties)) {
    const value = values[key];
    if (/^#[0-9a-f]{6}$/i.test(value || "")) root.style.setProperty(property, value);
    else root.style.removeProperty(property);
  }
}
